// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._benefitsFootnote__paragraph_qavg5_1.ant-5_24_1-typography.perxis-auto-1_18_1-typography.perxis-auto-1_18_1-paragraph {
  margin: var(--perxis-auto-gap-vertical-green-inner) 0 0 0;
}
._benefitsFootnote__paragraph_qavg5_1.ant-5_24_1-typography.perxis-auto-1_18_1-typography.perxis-auto-1_18_1-paragraph:first-child {
  margin-top: 0;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
